// Unpublished Work © 2021-2024 Deere & Company.

export default {
    ONAPPLY: 'onapply',
    ONEQUIP: 'onequip',
    ONGOLF: 'ongolf',
    ONLABOR: 'onlabor',
    ONPERFORM: 'onperform'
};
